import React from 'react'
import ChatIcon from "../images/chat-icon.svg";

const ChatLoader = () => {
  return (
    <div className="chat-loader">
      <img src={ChatIcon} alt="ChatIcon" className='chat-icon' />
      <div className="dots-container">
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
      </div>
    </div>
  )
}

export default ChatLoader